/**
 * Approval Actions for Story 2: Dynamic Approval Workflow
 * Manages pending approvals, review, approve/reject actions
 */

// Action Types
export const SET_USER_INFO = "SET_USER_INFO";
export const SET_PENDING_APPROVALS = "SET_PENDING_APPROVALS";
export const SET_APPROVAL_LOADING = "SET_APPROVAL_LOADING";
export const SET_APPROVAL_ERROR = "SET_APPROVAL_ERROR";
export const SET_CURRENT_REVIEW = "SET_CURRENT_REVIEW";
export const APPROVE_BOOKING_SUCCESS = "APPROVE_BOOKING_SUCCESS";
export const REJECT_BOOKING_SUCCESS = "REJECT_BOOKING_SUCCESS";
export const SET_APPROVAL_HISTORY = "SET_APPROVAL_HISTORY";
export const CLEAR_CURRENT_REVIEW = "CLEAR_CURRENT_REVIEW";

// Action Creators
export const setUserInfo = (payload) => {
  return { type: SET_USER_INFO, payload };
};

export const setPendingApprovals = (payload) => {
  return { type: SET_PENDING_APPROVALS, payload };
};

export const setApprovalLoading = (payload) => {
  return { type: SET_APPROVAL_LOADING, payload };
};

export const setApprovalError = (payload) => {
  return { type: SET_APPROVAL_ERROR, payload };
};

export const setCurrentReview = (payload) => {
  return { type: SET_CURRENT_REVIEW, payload };
};

export const approveBookingSuccess = (payload) => {
  return { type: APPROVE_BOOKING_SUCCESS, payload };
};

export const rejectBookingSuccess = (payload) => {
  return { type: REJECT_BOOKING_SUCCESS, payload };
};

export const setApprovalHistory = (payload) => {
  return { type: SET_APPROVAL_HISTORY, payload };
};

export const clearCurrentReview = () => {
  return { type: CLEAR_CURRENT_REVIEW };
};
